import React, { useEffect, useState } from "react";
import { ProductSlideContainer } from "./style";
import { FiX } from "react-icons/fi";
const ProductSlide = ({ post, resetPost }) => {
  const [status, setStatus] = useState(false);
  useEffect(() => {
    if (post) {
      let timeOut = setTimeout(() => {
        setStatus(true);
      }, 200);
      return timeOut;
    }
  }, [post]);
  useEffect(() => {
    if (status === "close") {
      let timeOut = setTimeout(() => {
        setStatus(false);
        resetPost();
      }, 700);
      return timeOut;
    }
  }, [status, resetPost]);

  return (
    <ProductSlideContainer
      status={post}
      contentStatus={status}
      onClick={() => setStatus("close")}
    >
      <div className="content-motion">
        <div
          className="container content"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {post ? (
            <div className="post-box">
              <div className="title">
                <h1>{post.title?.rendered}</h1>
                <FiX className="close" onClick={() => setStatus("close")} />
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: post.content?.rendered }}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </ProductSlideContainer>
  );
};
export default ProductSlide;
